<template>
  <div class="nav">
    <div>
      <el-menu :default-active="activeIndex"
               class="el-menu-demo nav-container"
               mode="horizontal"
               @select="handleSelect"
               background-color="rgba(176,214,0,0.75)"
               text-color="#fff"
               active-text-color="#fff">
        <el-menu-item index="1" class="nav-home"><router-link to="/home">{{$t("header.home")}}</router-link></el-menu-item>
        <el-submenu index="2" class="nav-about">
          <template slot="title"><router-link to="/about">{{$t("header.about.index")}}</router-link></template>
          <el-menu-item index="2-1"><router-link to="/about">{{$t("header.about.company")}}</router-link></el-menu-item>
          <el-submenu index="2-2">
            <template slot="title"><router-link to="/about/sign">{{$t("header.about.brand.index")}}</router-link></template>
            <el-menu-item index="2-4-1"><router-link to="/about/sign">{{$t("header.about.brand.symbol")}}</router-link></el-menu-item>
            <el-menu-item index="2-4-2"><router-link to="/about/idea">{{$t("header.about.brand.idea")}}</router-link></el-menu-item>
          </el-submenu>
          <el-menu-item index="2-3"><router-link to="/about/history">{{$t("header.about.history")}}</router-link></el-menu-item>

        </el-submenu>
        <el-menu-item index="3" class="nav-main"><router-link to="/main">{{$t("header.main")}}</router-link></el-menu-item>
        <el-menu-item index="7" class="nav-main"><router-link to="/quality">{{$t("header.quality")}}</router-link></el-menu-item>
        <el-menu-item index="4" class="nav-news"><router-link to="/news">{{$t("header.news")}}</router-link></el-menu-item>
        <el-menu-item index="5" class="nav-join"><router-link to="/join">{{$t("header.join")}}</router-link></el-menu-item>
        <el-menu-item index="6" class="nav-contact"><router-link to="/contact">{{$t("header.contact")}}</router-link></el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  data () {
    return {
      activeIndex: ''
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.activeIndex = key
    }
  },
  mounted () {
  },
  watch: {
    $route (to, from) {
      // console.log('111111')
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  a
    color #FFF
    padding 5px 10px
    font-size 19px
  .nav
    height 60px
    font-family "Source Han Sans CN Normal"
    overflow hidden
    .nav-container
      sfkContainer()
      letter-spacing 2px
      background-color rgba(176,214,0,1)
</style>



// WEBPACK FOOTER //
// src/common/navigation/Navigation.vue